<app-fn-ui-navigation-tree [treeConfig]="treeConfig"
                           [treeModel]="navigationTree.nodes"
                           [selectedNode]="selectedTreeNode">
</app-fn-ui-navigation-tree>
